import { css } from '@obvio/app'
import { RichText } from '@obvio/template'

import { FadeIn } from '../FadeIn'
import { TextSection } from '../TextSection'

import type { ReactElement } from 'react'

type ArtistDescriptionProps = {
  description: string
}

const outerCss = css`
  position: relative;
  background-color: transparent;
`

export function ArtistDescription({
  description,
}: ArtistDescriptionProps): ReactElement {
  return (
    <TextSection outerCss={outerCss}>
      <FadeIn>
        <span>ARTIST STATEMENT</span>
      </FadeIn>
      <FadeIn>
        <RichText asMap={{ h2: 'h4' }} value={description} />
      </FadeIn>
    </TextSection>
  )
}
